// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"546274bc","192":"dde3f3f5","199":"9561aeb4","331":"fdbfa4a0","393":"9f371a57","481":"36721e12","607":"0d04aa4c","771":"f0e3bcc7","842":"d09da199","867":"36f4f663","908":"283b89cd","930":"527739c4","973":"05c98a94"}[chunkId] + ".chunk.js";
};